<template>
  <div class="min-h-screen bg-white flex flex-col">
    <!-- Header -->
    <header class="ticket-header sticky top-0 z-50 bg-white">
      <div class="ticket-container ticket-header-content">
        <!-- Left: Logo -->
        <a href="/" class="ticket-header-logo">
          <img src="/logo.png" alt="La Billetterie Officielle" class="h-8" />
        </a>

        <!-- Center: Navigation -->
        <nav class="ticket-header-nav">
          <a
            v-for="item in navItems"
            :key="item.key"
            @click="handleNavClick(item)"
            class="ticket-header-nav-item"
            :class="{ active: activeNav === item.key }"
          >
            <span v-if="item.icon" class="mr-1">{{ item.icon }}</span>
            {{ item.label }}
          </a>
        </nav>

        <!-- Right: User Menu -->
        <div class="ticket-header-user-menu">
          <span class="ticket-text-sm ticket-font-medium">Devenir organisateur</span>
          <div class="w-8 h-8 bg-gray-500 rounded-full flex items-center justify-center">
            <svg class="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clip-rule="evenodd"/>
            </svg>
          </div>
        </div>
      </div>
    </header>

    <!-- Main Content -->
    <main class="flex-1 overflow-auto">
      <slot></slot>
    </main>

    <!-- Footer (minimal) -->
    <footer class="border-t border-gray-200 bg-gray-50 py-8">
      <div class="ticket-container">
        <p class="ticket-text-sm ticket-text-secondary text-center">
          © {{ currentYear }} La Billetterie Officielle. Tous droits réservés.
        </p>
      </div>
    </footer>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';

const activeNav = ref('tickets');
const currentYear = computed(() => new Date().getFullYear());

const navItems = [
  { key: 'tickets', label: 'Tickets', icon: '' },
  { key: 'experiences', label: 'Expériences', icon: '' },
];

const handleNavClick = (item) => {
  activeNav.value = item.key;
  // Navigation logic here via event bus or router
};
</script>
